import { typography } from "@iewc/Utilities/styleguide";
import { colorStrings, fontFamilyHeader, mediaQueriesBP } from "@iewc/Utilities/variables";
import { linkListStyles as styles } from "@insite/content-library/Widgets/Basic/LinkList";
import { LinkPresentationProps } from "@insite/mobius/Link";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.titleWrapper = {
    ...styles.titleWrapper,

    css: css`
        ${styles.titleWrapper?.css}

        & > a.list-title {
            &&&& span {
                color: ${getColor(colorStrings.textMain)};
            }

            ${TypographyStyle} {
                color: ${getColor(colorStrings.textMain)};
                text-transform: none;
                font-family: ${fontFamilyHeader};
                font-size: 24px;
                line-height: 30px;
                font-weight: 700;
                ${mediaQueriesBP.minMD} {
                    font-size: 29px;
                    line-height: 35px;
                }
            }
        }
    `,
};

styles.title = {
    ...styles.title,
    ...typography.h3,
    css: css`
        ${styles.title?.css}
        ${TypographyStyle} {
            font-size: 24px;
            line-height: 30px;
            ${mediaQueriesBP.minMD} {
                font-size: 29px;
                line-height: 35px;
            }
        }
    `,
};

styles.linkListWrapper = {
    ...styles.linkListWrapper,
    css: css`
        ${styles.linkListWrapper?.css}
        ${TypographyStyle} {
            text-transform: none;
        }

        a.list-link {
            &&&& span {
                color: ${getColor(colorStrings.textMain)};
            }
        }
    `,
};
